(()=>{
  'use strict';
  async function init(root){
    if(root.dataset.started)return;root.dataset.started='true';
    const engine=window.BolesLadiesMatching;if(!engine)return;
    const source=engine.classify(JSON.parse(root.querySelector('[data-blr-source]').textContent));
    window.bolesLadiesQA={source,results:null,status:'loading'};
    if(!source.eligible){root.hidden=true;window.bolesLadiesQA.status='excluded';return;}
    const old=document.getElementById('shopify-section-kt_relatedProduct');if(old)old.hidden=true;
    const base=root.dataset.base.replace(/\/$/,'');
    const scoped=url=>new URL(url,location.origin);
    let products=[],pending,loaded=false,running=false;
    const rejected=new Set(),cardCache=new Map();
    async function card(p){
      if(cardCache.has(p.id))return cardCache.get(p.id).cloneNode(true);
      const u=scoped(base+'/products/'+encodeURIComponent(p.handle));u.searchParams.set('view','boles-ladies-card');
      const response=await fetch(u,{cache:'no-store'});if(!response.ok)return null;
      const html=new DOMParser().parseFromString(await response.text(),'text/html'),el=html.querySelector('.blr-card');if(!el)return null;
      el.querySelectorAll('a[href]').forEach(a=>{if(window.Shopify?.theme?.role!=='main'&&location.search.includes('preview_theme_id')){const link=new URL(a.href);link.searchParams.set('preview_theme_id',root.dataset.theme);a.href=link.href;}});
      cardCache.set(p.id,el);return el.cloneNode(true);
    }
    function selectedSize(){
      const select=document.querySelector('form[action*="/cart/add"] [name="id"]');
      const data=document.querySelector('[id^="ProductJson-"]');if(!select||!data)return '';
      try{const p=JSON.parse(data.textContent),v=p.variants.find(v=>String(v.id)===select.value),idx=p.options.findIndex(o=>/size/i.test(typeof o==='string'?o:o.name));return v&&idx>=0?engine.norm(v.options[idx]).replace(/^size /,''):'';}catch{return '';}
    }
    async function render(){
      if(running||!loaded)return;running=true;
      try{
        let result;
        for(let retry=0;retry<8;retry++){
          result=engine.select(source,products.filter(p=>!rejected.has(p.id)),{size:selectedSize()});
          if(root.dataset.related==='false')result.related=[];
          if(root.dataset.look==='false')result.look=[];
          const lists=[...result.related,...result.look];
          const cards=await Promise.all(lists.map(r=>card(r.product)));
          let missing=false;cards.forEach((el,i)=>{if(!el){rejected.add(lists[i].product.id);missing=true;}});
          if(missing)continue;
          for(const [key,selector]of [['related','[data-blr-related]'],['look','[data-blr-look]']]){
            const section=root.querySelector(selector),track=section.querySelector('.blr-track');
            track.replaceChildren(...result[key].map(r=>cardCache.get(r.product.id).cloneNode(true)));section.hidden=!result[key].length;
          }
          root.hidden=!result.related.length&&!result.look.length;
          window.bolesLadiesQA.results=result;window.bolesLadiesQA.status='ready';root.dataset.status='ready';break;
        }
      }finally{running=false;}
    }
    async function load(){
      products=[];loaded=false;rejected.clear();
      try{
        await Promise.all(['women','clothing'].map(async collection=>{
        let url=scoped(base+'/collections/'+collection);url.searchParams.set('view','boles-ladies-data');url.searchParams.set('filter.v.availability','1');
        let pages=0;while(url&&pages<20){
          const response=await fetch(url,{cache:'no-store'});if(!response.ok)throw new Error('catalogue');
          const data=JSON.parse(await response.text());products.push(...data.products.map(engine.classify));
          url=data.next?scoped(data.next):null;if(url){url.searchParams.set('view','boles-ladies-data');url.searchParams.set('filter.v.availability','1');}pages++;
        }
        }));
        products=[...new Map(products.map(p=>[p.id,p])).values()];loaded=true;
        window.bolesLadiesQA.catalogueCount=products.length;await render();
      }catch(error){root.hidden=true;window.bolesLadiesQA.status='error';root.dataset.status='error';}
    }
    root.querySelectorAll('[data-blr-prev],[data-blr-next]').forEach(button=>button.addEventListener('click',()=>{const track=button.closest('section').querySelector('.blr-track');track.scrollBy({left:track.clientWidth*(button.hasAttribute('data-blr-prev')?-1:1),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});}));
    document.addEventListener('change',()=>{clearTimeout(pending);pending=setTimeout(render,200);});
    window.addEventListener('pageshow',e=>{if(e.persisted){cardCache.clear();load();}});
    await load();
  }
  function start(){document.querySelectorAll('[data-boles-ladies]').forEach(root=>{const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){observer.disconnect();init(root);}},{rootMargin:'1600px'});observer.observe(root);});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
  document.addEventListener('shopify:section:load',start);
})();
